export default `
mutation CreateClientWithEmail($serviceProviderId: ID!, $propertyIds: [ID!]!, $firstName: String!, $lastName: String!, $email: AWSEmail!) {
  createClientWithEmail(serviceProviderId: $serviceProviderId, propertyIds: $propertyIds, firstName: $firstName, lastName: $lastName, email: $email) {
    id
    serviceProviderId
    updatedAt
    propertyIds
    firstName
    lastName
    email
    isArchived
    isDeleted
  }
}
`;
